import { getProductByID } from './woocommerce';
import wooCommerceStore from '@/stores/woocommerceStore';

const validateProduct = async (item) => {
  try {
    if (item.type === 'variable') {
      const [parentResponse, variationResponse] = await Promise.all([
        getProductByID(item.parent_id),
        getProductByID(item.id),
      ]);

      const isValid = parentResponse.status === 'success' &&
                     variationResponse.status === 'success' &&
                     parentResponse.data.status === 'publish' &&
                     variationResponse.data.status === 'publish';

      const isInStock = variationResponse.data.stock_status === 'instock';
      const dateModifiedChanged = item.date_modified !== variationResponse.data.date_modified;

      return {
        isValid,
        isInStock,
        dateModifiedChanged,
        newData: dateModifiedChanged ? {
          ...variationResponse.data,
          date_modified: variationResponse.data.date_modified,
        } : null,
        latestDateModified: variationResponse.data.date_modified,
      };
    } else {
      // For simple products
      const response = await getProductByID(item.id);

      const isValid = response.status === 'success' && response.data.status === 'publish';
      const isInStock = response.data.stock_status === 'instock';
      const dateModifiedChanged = item.date_modified !== response.data.date_modified;

      return {
        isValid,
        isInStock,
        dateModifiedChanged,
        newData: dateModifiedChanged ? {
          ...response.data,
          date_modified: response.data.date_modified,
        } : null,
        latestDateModified: response.data.date_modified,
        isError: false,
      };
    }
  } catch (error) {
    console.log('catch');
    console.error(`Error validating product ${item.id}:`, error);
    return {
      isValid: false,
      isInStock: false,
      dateModifiedChanged: false,
      newData: null,
      latestDateModified: item.date_modified || null,
      isError: true,
    };
  }
};

export const syncCart = async ({ preview = false } = {}) => {
  try {
    const initialCart = wooCommerceStore.cart;
    if (!initialCart || initialCart.length === 0) return;

    const updatedCart = [];
    const originalItems = [...initialCart];
    const invalidItems = [];
    const outOfStockItems = [];
    const changedItems = [];

    for (const item of initialCart) {
      if (!item.id) {
        updatedCart.push({ ...item, sync_status: false });
        continue;
      }

      const validation = await validateProduct(item);

      // If we faced with an error, skip the product
      if (validation.isError) {
        console.log('isError', validation);
        updatedCart.push({
          ...item,
          sync_status: false,
        });
        continue;
      }

      // If product is not valid or not in stock, mark as sync_status: false and remove from cart
      if (!validation.isValid) {
        invalidItems.push(item);
        continue;
      }
      if (!validation.isInStock) {
        outOfStockItems.push(item);
        continue;
      }

      // If product has changed (date_modified), update it and add to changedItems
      if (validation.dateModifiedChanged) {
        const updatedItem = {
          ...item,
          ...validation.newData,
          sync_status: true,
        };
        changedItems.push({ original: item, updated: updatedItem });
        updatedCart.push(updatedItem);
      } else {
        // Product is valid, in stock, and up-to-date
        updatedCart.push({
          ...item,
          sync_status: true,
          date_modified: validation.latestDateModified,
        });
      }
    }

    // Only update the store and localStorage if not preview
    if (!preview) {
      wooCommerceStore.setCart(updatedCart);
    }

    wooCommerceStore.setCartSyncData({
      invalidItems,
      outOfStockItems,
      changedItems,
      validItems: updatedCart.filter(i => i.sync_status),
      originalItems,
      updatedCart,
    });

    return {
      validItems: updatedCart.filter(i => i.sync_status),
      invalidItems: updatedCart.filter(i => !i.sync_status),
      changedItems,
      originalItems,
      updatedCart,
    };
  } catch (error) {
    console.error('Error during cart sync:', error);
    return {
      validItems: wooCommerceStore.cart,
      invalidItems: [],
      changedItems: [],
      originalItems: [],
      updatedCart: wooCommerceStore.cart,
    };
  }
};